import { Component, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { EbwModalService } from 'src/app/library/ebw-modals-angular/ebw-modal.service';
import { NamService } from 'src/app/servizi/nam/nam.service';
import { TemplateService } from 'src/app/servizi/nam/template.service';
import { Collection, Data, Enumerator, Field } from '../../model/config-api-response.interface';
import { NamApiResponse } from '../../model/nam-api-response.interface';

@Component({
  selector: 'app-template-details',
  templateUrl: './template-details.component.html',
  styleUrls: ['./template-details.component.scss']
})
export class TemplateDetailsComponent implements OnInit {

  constructor(
    public templateService: TemplateService,
    private namService: NamService,
    private ebwModalService: EbwModalService
  ) { }

  collection: Collection;
  fieldList: Field[] = [];
  formFields: { [key: string]: { model: string, valid: boolean } } = {};

  config = null;
  enumerators: { [key: string]: string[] } = null;

  async ngOnInit() {
    this.collection = this.templateService.collection;
    this.fieldList = this.collection.fields.filter((field) => !field.readonly);

    for(let field of this.fieldList){
      this.formFields[field.name] = {
        model: "",
        valid: true
      };
    }
    
    //let configurationData: Data = null;
    await this.namService.getApiConfiguration()
      .pipe(take(1))
      .subscribe((config: NamApiResponse<Data>) => {
        this.enumerators = {};
        let allEnumerators = config.data.enumerators;
        allEnumerators.forEach((element: Enumerator) => {
          this.enumerators[element.name] = element.values;
        });
      });
  }

  validateForm(){
    let valid = true;
    for(let field of this.fieldList){
      this.formFields[field.name].valid = true;
      if(this.formFields[field.name].model == null || this.formFields[field.name].model == "" && field.mandatory){
        valid = false;
        this.formFields[field.name].valid = false;
      }
    }
    return valid;
  }

  salvaTemplate(){
    const propertiesJson = {};
    let valid = this.validateForm();

    let fields = this.collection.fields.filter((field) => !field.readonly || field.defaultValue != null);

    if (valid) {
      for (let field of fields) {
        if (this.formFields[field.name]) {
          propertiesJson[field.name] = this.formFields[field.name].model
        } else if (field.defaultValue) {
          propertiesJson[field.name] = field.defaultValue;
        }
      }

      const propertiesString = JSON.stringify(propertiesJson);
      this.templateService.sendTemplate(propertiesString);
    } else {
      this.ebwModalService.openErrorModal({
        title: "Errore",
        content: "Per salvare è necessario popolare tutti i campi obbligatori"
      });
    }
    
  }

}
